import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { BiBullseye } from 'react-icons/bi';

export default function PostHeader({ title, date, comp }) {
  const pad = comp ? '30px 0 15px 0' : '30px 0';

  const PostHeaderStyles = styled.header`
    padding: ${pad};
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
    .sub-bar {
      font-size: 14px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
        'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
        'Helvetica Neue', sans-serif;
      color: #999;
    }
    .post-date {
      display: flex;
      align-items: center;

      svg {
        margin-right: 5px;
        color: var(--accent);
        font-size: 20px;
      }
    }
  `;

  return (
    <PostHeaderStyles>
      <h2>{title}</h2>
      <div className="sub-bar">
        <span className="post-date">
          {' '}
          <BiBullseye /> {moment(date).format('Do MMMM YYYY')}
        </span>
      </div>
    </PostHeaderStyles>
  );
}

PostHeader.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.any.isRequired,
  comp: PropTypes.string,
};
